export default __webpack_public_path__ + "73ea273a72f4aca30ca528cf9117470a.woff2";